import React, { useEffect, useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { Box, Button, Typography } from '@mui/joy';
import projectApi from '../api/project';
import ProjectTable from '../components/ProjectTable';
import ProjectCreateModal from '../components/ProjectCreateModal';
import { IProject } from '../interface/IProject';
import { useToast } from '../helper/ToastProvider';

type Props = {};

const Projects = (props: Props) => {
  const { showToast } = useToast();
  const [projects, setProjects] = useState();
  const [openProjectCreateModal, setOpenProjectCreateModal] = useState<boolean>(false);
  const [selectedProject, setSelectedProject] = useState<IProject | null>(null);

  useEffect(() => {
    _getAllProjects();
  }, []);

  const _getAllProjects = async () => {
    try {
      const { data } = await projectApi.getAllProjects();
      setProjects(data);
    } catch (e) {
      showToast({
        message: 'Project Fetch Failed',
        severity: 'danger',
      });
    }
  };

  const closeProjectCreateModal = () => {
    setOpenProjectCreateModal(false);
    setSelectedProject(null);
  };

  return (
    <>
      <Breadcrumb crumb={['Projects']} />
      <Box
        sx={{
          display: 'flex',
          mb: 1,
          gap: 1,
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'start', sm: 'center' },
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Typography level='h2' component='h1'>
          Projects
        </Typography>
        <Button
          color='primary'
          onClick={() => setOpenProjectCreateModal(true)}
          // startDecorator={<PersonAddRoundedIcon />}
          size='sm'
        >
          Create New
        </Button>
      </Box>
      {projects && (
        <>
          <ProjectTable
            projects={projects}
            onEdit={(project) => {
              setSelectedProject(project);
              setOpenProjectCreateModal(true);
            }}
            onDelete={async (projectId) => {
              await projectApi.deleteProject(projectId);
              await _getAllProjects();
            }}
          />
          {/* <OrderList /> */}
        </>
      )}
      <ProjectCreateModal
        open={openProjectCreateModal}
        onClose={closeProjectCreateModal}
        onSave={async () => {
          try {
            await _getAllProjects();
            showToast({
              message: 'Project Create/Update Success',
              severity: 'success',
            });
          } catch (e) {
            showToast({
              message: 'Project Create/Update Failed',
              severity: 'danger',
            });
          }
          closeProjectCreateModal();
        }}
        selectedProject={selectedProject!}
      />
    </>
  );
};
export default Projects;
